// Contracts §8.7: RPC errors are {"error": "<code>"}. Works on an RTK query
// error and on the value an RTK mutation's unwrap() rejects with.
export const rpcErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null || !('data' in error))
    return undefined;
  const { data } = error as { data?: unknown };
  if (typeof data !== 'object' || data === null || !('error' in data))
    return undefined;
  const code = (data as { error?: unknown }).error;
  return typeof code === 'string' ? code : undefined;
};
